<!-- <nav>
  <ul class="pagination justify-content-center pt-4">
    <li class="page-item"><a class="page-link" href="javascript:void(0)" (click)="prev()">Previous</a></li>
    <li class="page-item"><a class="page-link" href="javascript:void(0)" (click)="next()">Next</a></li>
  </ul>
</nav> -->

<nav >
  <ul class="pagination justify-content-center pt-5">
    <li class="page-item ">
      <a class="page-link" href="javascript:void(0)" (click)="prev()" aria-label="Previous">
        <span aria-hidden="true">&laquo;</span>
        <span class="sr-only">Previous</span>
      </a>
    </li>

    <li class="page-item"><a class="page-link" href="#">1</a></li>
    <li class="page-item"><a class="page-link" href="#">2</a></li>
    <li class="page-item"><a class="page-link" href="#">3</a></li>

    <li class="page-item">
      <a class="page-link" href="javascript:void(0)" (click)="next()" aria-label="Next">
        <span aria-hidden="true">&raquo;</span>
        <span class="sr-only">Next</span>
      </a>
    </li>
  </ul>
</nav>